import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Layoutcreatepage from "../../../components/common/Form/Create-Layout";
import { usePostBranchMutation } from "../../../store/api/branch";
const Create = () => {
  const navigate = useNavigate();
  const [createBranch] = usePostBranchMutation();
  const [loading, setLoading] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState({
    type: "",
    message: "",
  });

  const fields = [
    {
      name: "branch_name",
      label: "Branch Name",
      type: "text",
      placeholder: "Enter Branch Name",
      required:true
    },
  ];

  const initialValues = {
    branch_name: ""
  };

  const validationSchema = Yup.object({
    branch_name: Yup.string().required(" Branch name  is required"),
  });
  const handleCancel = () => {
    navigate("/gym-branch-list",{ state: { pageName: "Branch" } });
  };

  const onSubmit = async (values, { setSubmitting }) => {
    try {

      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => {
          formData.append(key, value);
      });
      const response = await createBranch(formData);
      setLoading(true);
      if(response.error){
        setFeedbackMessage({
          type: "error",
          message: response?.error?.data?.error,
          });
      }else{
        if (response.data.branch_name === values.branch_name) {
          setFeedbackMessage({
            type: "success",
            message: "Branch created successfully!",
          });
          
          setTimeout(() => {
            navigate("/gym-branch-list" ,{ state: { pageName: "Branch" } });
          }, 2000);
        } 
      }
      
    } catch (error) {
      console.error("Error:", error);
      setFeedbackMessage({
        type: "error",
        message: error?.message || "Something went wrong.",
      });
    } finally {
      setSubmitting(false);
      setLoading(false);
    }
  };

  return (
    <div className="pb-4 pt-3 ">
      <Layoutcreatepage
        title="Add Branch"
        fields={fields}
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={onSubmit}
        buttonText="Add Branch"
        navigateTo="/gym-branch-list"
        loading={loading}
        feedbackMessage={feedbackMessage}
        onCancel={handleCancel} 
      />
    </div>
  );
};

export default Create;
